import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

const HOME = 'https://media.easy-peasy.ai/landing/home';

const FinalCta = () => {
  const { t } = useLocale('home');

  return (
    <section className='relative overflow-hidden bg-[#050509] py-32 lg:py-44'>
      {/* Generated aurora backdrop — calm center keeps the text legible */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`${HOME}/final-cta-bg.webp`}
        alt=''
        loading='lazy'
        decoding='async'
        className='absolute inset-0 h-full w-full object-cover'
      />
      <div className='pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_55%_50%_at_50%_50%,rgba(5,5,9,0.55),transparent_75%)]' />
      <div className='pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#050509] to-transparent' />
      <div className='pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#050509] to-transparent' />

      {/* Content — deliberately minimal, Magnific's "Be Magnific" pattern */}
      <div className='relative z-10 mx-auto max-w-5xl px-4 text-center sm:px-6'>
        <h2 className='text-6xl font-extrabold tracking-tight text-white sm:text-7xl lg:text-8xl'>
          {t('Make it.')}{' '}
          <span className='bg-gradient-to-r from-indigo-300 via-violet-300 to-fuchsia-300 bg-clip-text pb-2 text-transparent'>
            Easy-peasy.
          </span>
        </h2>
        <div className='mt-10'>
          <Link
            href='/login#auth-sign-up'
            className='group inline-flex h-[60px] min-w-[240px] items-center justify-center gap-2 rounded-full bg-indigo-500 px-10 text-lg font-bold text-white shadow-[0_8px_40px_-8px_rgba(99,102,241,0.7)] transition-all hover:bg-indigo-400 hover:shadow-[0_8px_50px_-6px_rgba(99,102,241,0.9)]'
          >
            {t('Start creating free')}
            <span
              aria-hidden='true'
              className='transition-transform group-hover:translate-x-1'
            >
              →
            </span>
          </Link>
        </div>
        <div className='mt-4 text-sm font-medium text-slate-400'>
          {t('Free to start. Cancel anytime.')}
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
